import React from 'react';

interface PlusIconProps {
  className?: string;
  style?: React.CSSProperties;
}

const PlusIcon: React.FC<PlusIconProps> = ({ className, style }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M8 0C3.58173 0 0 3.58173 0 8C0 12.4183 3.58173 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0ZM8 15C4.1402 15 1 11.8598 1 8C1 4.1402 4.1402 1 8 1C11.8598 1 15 4.1402 15 8C15 11.8598 11.8598 15 8 15ZM11.5 8C11.5 8.27637 11.2764 8.5 11 8.5H8.5V11C8.5 11.2764 8.27637 11.5 8 11.5C7.72363 11.5 7.5 11.2764 7.5 11V8.5H5C4.72363 8.5 4.5 8.27637 4.5 8C4.5 7.72363 4.72363 7.5 5 7.5H7.5V5C7.5 4.72363 7.72363 4.5 8 4.5C8.27637 4.5 8.5 4.72363 8.5 5V7.5H11C11.2764 7.5 11.5 7.72363 11.5 8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlusIcon;
